module.exports = __webpack_public_path__ + "img/1-gallery.25ed44a8.png";